export enum LevelTypes {
  Standard = 1,
  Final = 2,
  Invitation = 3,
}
